import { notSelectedValue } from "@pages/shops/[uuid]/request_reservation";
import { createReservationDateOptionValue } from "@pages/shops/[uuid]/request_reservation/_reservationDateOptionValue";
import { ReservationFormRow } from "@components/pages/shops/[uuid]/request_reservation/ReservationFormRow";
import { ReservationFormSelect } from "@components/pages/shops/[uuid]/request_reservation/ReservationFormSelect";
import type { UsersReservationVisitDatesType } from "@graphql/__generated__/types";
import type { FC } from "react";

type Props = {
  dates: UsersReservationVisitDatesType[];
};

export const ReservationFormDateRow: FC<Props> = ({ dates }) => {
  return (
    <ReservationFormRow title="来店日">
      <ReservationFormSelect name={"date"} required={true}>
        <option value={notSelectedValue} disabled>
          選択してください
        </option>
        {dates.map((date, index) => {
          const value = createReservationDateOptionValue(date.date, index);
          const label = date.label;
          return (
            <option value={value} key={`${index}:${value}`}>
              {label}
            </option>
          );
        })}
      </ReservationFormSelect>
    </ReservationFormRow>
  );
};
